import { render, staticRenderFns } from "./ModalSearch.vue?vue&type=template&id=580e98e6&scoped=true"
import script from "./ModalSearch.vue?vue&type=script&lang=js"
export * from "./ModalSearch.vue?vue&type=script&lang=js"
import style0 from "./ModalSearch.vue?vue&type=style&index=0&id=580e98e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580e98e6",
  null
  
)

export default component.exports